import React from 'react';
import {BrowserRouter as Router,Route,Switch} from 'react-router-dom'
import RowsProvider from './context/RowsContext';
import Home from './pages/Home'
import { AuthProvider } from './context/Auth';
import PrivateRoute from './utils/PrivateRoute';
import LoginPage from './pages/LoginPage';
import { ConfigProvider } from 'antd';
import es_ES from 'antd/es/locale/es_ES';
import ResetPassword from './pages/ResetPassword';

function App() {
  return (
    <AuthProvider>
      <ConfigProvider locale={es_ES} >
        <Router>
              <Switch>
                    <RowsProvider>
                    <PrivateRoute exact path="/" component={ Home }/>
                    <Route exact path="/login" component={ LoginPage }/>
                    <Route exact path="/reset" component={ ResetPassword }/>
                    </RowsProvider>
                  
              </Switch>
        </Router>

      </ConfigProvider>
    </AuthProvider>
    
  );
}

export default App;
